module.exports = __webpack_public_path__ + "img/20.3a9a0933.jpg";